<template>
  <section class="section">
      <div class="columns is-centered">
        <div class="column is-one-third">
          <div class="has-text-centered" style="margin-bottom: 1rem;">
            <span style="font-size: 1.75rem; font-weight: 700; letter-spacing: -0.5px; color: #3273dc;">Fooshi</span>
          </div>
          <div class="has-text-centered" style="margin-bottom: 1.5rem;">
            <LanguageSelector />
          </div>
          <h3 class="title is-4 is-spaced is-centered">
            <span>{{ $t('onboarding.forgotPassword.title') }}</span>
          </h3>
          <div v-if="sent" class="notification is-success is-light">
            {{ $t('onboarding.forgotPassword.sent') }}
          </div>
          <template v-else>
            <p class="block">{{ $t('onboarding.forgotPassword.intro') }}</p>
            <div class="field">
              <label class="label">{{ $t('onboarding.login.email') }}</label>
              <p class="control has-icons-left">
                <input v-focus class="input" type="email" placeholder="Email" autocomplete="email" v-model="email"
                    @input="errorMessage = ''"
                    v-on:keyup.enter="submit()"
                    v-bind:class="{
                      'is-danger': errorMessage
                    }" />
                <span class="icon is-small is-left">
                  <i class="fa fa-envelope"></i>
                </span>
              </p>
              <p class="help is-danger" v-if="errorMessage">
                {{ $t(errorMessage) }}
              </p>
            </div>
            <div class="field">
              <p class="control">
                <primary-button :label="$t('onboarding.forgotPassword.submit')" @click="submit()" class="is-fullwidth" :loading="loading"></primary-button>
              </p>
            </div>
          </template>
          <div class="field">
            <p class="control">
              <button class="button is-info is-light is-fullwidth" @click="backToLogin()">{{ $t('onboarding.forgotPassword.backToLogin') }}</button>
            </p>
          </div>
        </div>
      </div>
  </section>
</template>

<script>

import { FooshiApi } from '@/services/fooshiApi.service'
import { EmailValidator } from '@/services/emailValidator.service'
import PrimaryButton from '../../components/forms/PrimaryButton.vue'
import LanguageSelector from '../../components/LanguageSelector.vue'

export default {
  components: { PrimaryButton, LanguageSelector },
  methods: {
    async submit () {
      const email = this.email.trim()
      if (!EmailValidator.isValid(email)) {
        this.errorMessage = 'onboarding.signup.invalidEmailAddress'
        return
      }
      this.loading = true
      try {
        await FooshiApi.forgotPassword({ email, locale: this.$i18n.locale })
        this.sent = true
        if (window.plausible) window.plausible('Password Reset Requested', { props: { stage: 'retention' } })
      } catch (err) {
        this.errorMessage = err.status === 429
          ? 'onboarding.forgotPassword.rateLimited'
          : 'onboarding.forgotPassword.genericError'
      }
      this.loading = false
    },
    backToLogin () {
      this.$router.push('/login')
    }
  },
  data () {
    return {
      loading: false,
      sent: false,
      email: '',
      errorMessage: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/onBoarding/ForgotPassword.vue